package ar.corzo.firebase

import ar.corzo.firebase.npm.auth
import ar.corzo.firebase.npm.signInWithEmailAndPassword
import ar.corzo.firebase.npm.signOut
import kotlinx.coroutines.await

actual suspend fun getUser(): String? {
    return auth().currentUser?.uid
}

actual suspend fun getToken(): String? {
    return auth().currentUser?.accessToken
}

actual suspend fun logOut() {
    signOut(auth())
}

actual suspend fun createUser(email: String, password: String): String? {
    TODO()
}
actual suspend fun logUser(email: String, password: String): String? { // uid, uToken
    return try {
        signInWithEmailAndPassword(auth(), email, password).await().user.uid
    }catch (e: Throwable){
        console.error(e)
        null
    }
}
